import axios from "axios";

export const updatePassword = async (
  emailVerificationToken: string,
  password: string
): Promise<{ success: boolean; message?: string }> => {
  try {
    await axios.patch(
      `${process.env.REACT_APP_API_URL}/auth/forgot-password`,
      {
        password: password,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${emailVerificationToken}`,
        },
      }
    );
    return { success: true, message: "비밀번호가 재설정되었습니다." };
  } catch (error: any) {
    const statusCode = error.response.status;
    if (statusCode === 400) {
      return { success: false, message: "잘못된 비밀번호입니다." };
    } else if (statusCode === 401) {
      return { success: false, message: "이메일이 인증되지 않았습니다." };
    } else {
      return { success: false, message: "처리 중 문제가 발생하였습니다. 재시도해주세요." };
    }
  }
};
